import { Injectable } from '@angular/core';
import { ioteqDrawerComponent } from '@tools/components/drawer/drawer.component';

@Injectable({
    providedIn: 'root'
})
export class ioteqDrawerService
{
    private _componentRegistry: Map<string, ioteqDrawerComponent> = new Map<string, ioteqDrawerComponent>();

    /**
     * Constructor
     */
    constructor()
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register drawer component
     *
     * @param name
     * @param component
     */
    registerComponent(name: string, component: ioteqDrawerComponent): void
    {
        this._componentRegistry.set(name, component);
    }

    /**
     * Deregister drawer component
     *
     * @param name
     */
    deregisterComponent(name: string): void
    {
        this._componentRegistry.delete(name);
    }

    /**
     * Get drawer component from the registry
     *
     * @param name
     */
    getComponent(name: string): ioteqDrawerComponent | undefined
    {
        return this._componentRegistry.get(name);
    }
}
